import React from "react";

const GoldCard = ({
  textcolor,
  containerColor,
  containerBorderColor,
  metalName = "Gold",
  purity = "24K-999",
  pricePerGram = "9000.0",
  totalValue = "504.00",
  weight = "0.056 g",
  metalColor = "#FFD700",
  gradientColors
}) => {
  // Build gradient string if gradientColors provided
  const buildGradientString = (colors) => {
    if (!colors || colors.length === 0) return null;
    if (colors.length === 1) return `linear-gradient(135deg, ${colors[0]}, ${colors[0]})`;
    
    const colorStops = colors.map((color, index) => {
      const percentage = (index / (colors.length - 1)) * 100;
      return `${color} ${percentage}%`;
    }).join(", ");
    
    return `linear-gradient(135deg, ${colorStops})`;
  };

  const backgroundStyle = gradientColors && gradientColors.length > 0
    ? { background: buildGradientString(gradientColors) }
    : { background: containerColor || "transparent" };

  return (
    <div style={{ padding: "0 10px", marginBottom: "10px" }}>
      <div
        style={{
          borderRadius: "20px",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          opacity: 0.9,
          ...backgroundStyle,
          border: `1px solid ${containerBorderColor || "rgba(255, 255, 255, 0.4)"}`,
        }}
      >
        {/* Gold Icon/Badge */}
        <div
          style={{
            width: "70px",
            height: "70px",
            background: metalColor,
            borderRadius: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            color: "#756716ff",
            fontSize: "12px",
            fontWeight: "normal",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          }}
        >
          <div>{purity.split("-")[0]}-</div>
          <div>{purity.split("-")[1]}</div>
        </div>

        {/* Metal Info */}
        <div style={{ flex: 1 }}>
          <div
            style={{
              color: metalColor,
              fontSize: "16px",
              fontWeight: "600",
              marginBottom: "4px",
            }}
          >
            {metalName}
          </div>
          <div
            style={{
              color: textcolor,
              fontSize: "14px",
              fontWeight: "400",
            }}
          >
            ₹ {pricePerGram}/gm
          </div>
        </div>

        {/* Value Info */}
        <div style={{ textAlign: "right" }}>
          <div
            style={{
              color: textcolor,
              fontSize: "16px",
              fontWeight: "600",
              marginBottom: "4px",
              padding: "0 10px",
            }}
          >
            ₹ {totalValue}
          </div>
          <div
            style={{
              color: textcolor,
              fontSize: "12px",
              fontWeight: "400",
              padding: "0 10px",
            }}
          >
            {weight}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GoldCard;
